module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	"use strict";
	fox.registerWidget('UserOfferModelRelated', {
		_offerListAlias: 'offerModelRelated',

		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					purchaseApi: {
						widget: 'Api',
						method: 'Offer_ModelRelated.purchaseOffer'
					},
					infoPopup: {
						widget: 'Popup_Common',
						'dialog.width': '94%',
						additionalClasses: 'offermodel-popup',
						'widgets.content.template': 'offer_modelrelated_success_popup'
					},
					newLoginPopup: {
						widget: 'Popup_Common',
						'dialog.width': '94%',
						additionalClasses: 'offermodel-popup',
						widgets: {
							content: {
								widget: 'UserOfferNewLogin',
								template: 'offer_modelrelated_newlogin_popup'
							}
						}
					}
				},
				handleWom: {
					purchaseSuccess: {
						widget: '#purchaseApi',
						event: 'ready',
						callback: fox.bind(this.offerPurchased, this)
					},
					purchaseError: {
						widget: '#purchaseApi',
						event: 'failure',
						callback: fox.bind(this.offerError, this)
					}
				}
			});
			this.callParent('configure', arguments);
		},

		_getAccountPage: function () {
			var accountWidget = fox.wom.selectFirst('#home #account');
			if (!accountWidget) {
				this.log('UserOfferModelRelated: account page does not exists', {
					section: 'UserOfferModelRelated',
					action: 'addOfferToUserSettings'
				});
				return false;
			}

			return accountWidget;
		},

		actionAfterCancel: function (params) {
			if (fox.getEnv('user.canceled') !== 1) {// User_Cancel::STATUS_SUCCESS
				return true;
			}

			this.updateState('new');

			this.addOfferToUserSettings();
			this.dispatchUpdated();

			fox.Router.addRoute('after-cancel', '#home #afterCancel');
			fox.site.gotoPage('after-cancel');
		},

		actionUserRenewed: function () {
			var accountWidget = this._getAccountPage();
			var list = accountWidget.wom1('#' + this._offerListAlias);
			if (list) {
				list.removeSelf();
			}
		},

		actionOffersPrepared: function () {
			if (fox.getEnv('user.canceled') !== 1) {// User_Cancel::STATUS_SUCCESS
				return true;
			}

			var offerState = this._offer.get('userOffer.state');
			if (offerState === false || offerState === this.const.STATE_NEW || offerState === this.const.STATE_ACTIVE) {
				this.addOfferToUserSettings();
				this.dispatchUpdated();
				return true;
			}
		},

		addOfferToUserSettings: function () {
			var accountWidget = this._getAccountPage();

			if (!accountWidget.wom1('#' + this._offerListAlias)) {
				var listWidget = accountWidget.embedWidget(this._offerListAlias, 'UserOfferModelRelated_List');
				if (listWidget && accountWidget.isActive()) {
					listWidget.run();
				}
			}
		},

		dispatchUpdated: function () {
			this._controller.dispatchEvent('modelRelatedUpdated', this.alias);
		},

		actionPurchaseOffer: function (params) {
			var apiArgs = {
				offerAlias: this.alias,
				clientId: params.clientId
			};

			if (fox.isSet(params.login)) {
				apiArgs.login = params.login;
			}

			var api = this.rwom1('#purchaseApi');
			api.send(apiArgs);
		},

		offerPurchased: function (data) {
			this._controller.dispatchEvent('purchaseEventDone');
			
			if (data === true) {
				return true; //show successful popup or anything else
			}

			if (typeof data === 'string') {
				this.log('UserOfferModelRelated: redirect to: ' + data, {
					section: 'UserOfferModelRelated',
					action: 'offerPurchased'
				});
				window.location.href = data;
				return true;
			}
		},

		offerError: function (response) {
			var data = response.answer.data;
			this._controller.dispatchEvent('purchaseEventDone');

			if (data && data.checkingStatus === false) {
				if (data.email && data.email === false) {
					this.showInfoPopup({
						title: 'An account with this email already exists',
						text: 'If you forgot your password please <a href="http://' + data.domain + '/password-recovery">click here</a>'
					});
					return false;
				} else if (data.login === false) {
					this.wom1('#newLoginPopup #content').setOption('clientId', data.clientId);
					this.wom1('#newLoginPopup').show();
					return false;
				}
			}

			this.showInfoPopup(response.answer.reason);
			return false;
		},

		showInfoPopup: function(data) {
			if (!data) {
				return;
			}

			if (fox.isString(data)) {
				data = {
					title: 'Information',
					text: data
				};
			}

			var
				popup = this.wom1('#infoPopup'),
				content = popup.wom1('#content');

			content.setTemplateOptions({
				title: data.title || 'undefined',
				text: data.text || 'undefined'
			});

			content.render();
			popup.show();
		}
	}, 'UserOfferBase');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/offer/controllers/UserOfferModelRelated.js
// module id = 128
// module chunks = 4